import React from "react";
import { useSearchParams } from "react-router-dom";

// Tab state lives in ?tab= so reloads, back-links and notification deep-links land on the right tab.
export const useTabParam = (keys, fallback) => {
  const [sp, setSp] = useSearchParams();
  const raw = sp.get("tab");
  const tab = keys.includes(raw) ? raw : fallback;
  const setTab = (k) => {
    const next = new URLSearchParams(sp);
    next.set("tab", k);
    setSp(next, { replace: true });
  };
  return [tab, setTab];
};

export const DashTabs = ({ tabs, value, onChange, testid = "dash-tabs" }) => (
  <div className="mb-8 border-b border-[#1E3F33]/10" data-testid={testid} role="tablist">
    <div className="flex flex-wrap gap-x-1">
      {tabs.map(({ key, label, icon: Icon, count, alert }) => {
        const active = value === key;
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(key)}
            data-testid={`dash-tab-${key}`}
            className={`inline-flex items-center gap-2 px-3 sm:px-4 py-3 text-sm font-medium -mb-px border-b-2 whitespace-nowrap transition-colors ${active ? "border-[#CC5A3A] text-[#CC5A3A]" : "border-transparent text-[#5C6B64] hover:text-[#1E3F33]"}`}
          >
            {Icon && <Icon className="w-4 h-4" />} {label}
            {typeof count === "number" && (
              <span data-testid={`dash-tab-badge-${key}`} className={`min-w-[20px] h-5 px-1.5 inline-flex items-center justify-center rounded-full text-[10px] font-bold ${alert && count > 0 ? "bg-[#CC5A3A] text-white" : active ? "bg-[#CC5A3A]/12 text-[#CC5A3A]" : "bg-[#1E3F33]/8 text-[#5C6B64]"}`}>
                {count > 99 ? "99+" : count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  </div>
);
